module.exports = __webpack_public_path__ + "static/media/google.9ad1c65b.svg";